import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { createAuthLink, createErrorLink } from './apollo-links';
import { typePolicies } from './apollo-cache-config';

// Strawberry GraphQL v2 endpoint
const baseGraphQLUrl = import.meta.env.VITE_GRAPHQL_API_URL || 'http://localhost:8010/graphql/';

// Derive the v2 URL from the base: replace /graphql/ with /graphql-v2/
let v2Url = baseGraphQLUrl.startsWith('http://') || baseGraphQLUrl.startsWith('https://')
  ? baseGraphQLUrl
  : `http://${baseGraphQLUrl}`;

v2Url = v2Url.replace(/^http:\/\/0\.0\.0\.0:/, 'http://localhost:');
v2Url = v2Url.replace(/\/graphql\/?$/, '/graphql-v2/');

// Fallback: if URL didn't contain /graphql, append /graphql-v2/
if (!v2Url.endsWith('/graphql-v2/')) {
  v2Url = v2Url.replace(/\/+$/, '') + '/graphql-v2/';
}

const httpLink = createHttpLink({
  uri: v2Url,
});

const authLink = createAuthLink();
const errorLink = createErrorLink();

export const apolloClientV2 = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache({ typePolicies }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});
